import { render, staticRenderFns } from "./MultiGridsTransfer.vue?vue&type=template&id=12fc0ea5&scoped=true"
import script from "./MultiGridsTransfer.vue?vue&type=script&lang=js"
export * from "./MultiGridsTransfer.vue?vue&type=script&lang=js"
import style0 from "./MultiGridsTransfer.vue?vue&type=style&index=0&id=12fc0ea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc0ea5",
  null
  
)

export default component.exports